/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import IconButtonComponent from "../BasicInputs/IconButtonComponent.jsx";
import {Containers} from "../../Objects/Containers.jsx";
import useContainer from "../../hooks/useContainer.jsx";
import {names} from "../../Constants.js";

function ContainerActionsButton({containerId}) {
    const containerInfo = useContainer(containerId)

    function openContainerURL() {
        window.open("http://" + containerInfo.domain, '_blank', 'noopener,noreferrer')
    }

    function openSSH() {
        window.open(`ssh://${containerInfo.containerName}@${containerInfo.domain}:2222`, '_blank', 'noopener,noreferrer')
    }

    return (
        <div className="flex items-center gap-x-3 ">
            <IconButtonComponent text={`Restart Container`}
                                 iconName={"IoReload"}
                                 onClick={async () => {
                                     await Containers(containerId).action("restart")

                                 }}/>
            <IconButtonComponent
                iconName={"PiTrash"}
                text={`Remove ${names.container} `}
                onClick={async () => {
                    await Containers(containerId).remove()

                }}/>
            <IconButtonComponent text={`Connect via ssh`}
                                 iconName={"PiTerminalWindow"}
                                 onClick={() => openSSH()}/>


            <IconButtonComponent
                text={"Open URL"}
                iconName={"PiArrowSquareOut"}
                onClick={() => openContainerURL()}/>
        </div>
    );
}

export default ContainerActionsButton;